import styled from "styled-components";

const ButtonBox = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 20px 0;
  background: #ffffff;
`;

export default ButtonBox
